module.exports = __webpack_public_path__ + "media/icons/cuk_phone-856427e2.png";